/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment.ts";

function getPostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/invoice-future-payment` as const,
  };
  return res;
}

/**
 * @description Marca a antecipação de emissão de NF (data de hoje, corpo e usuário); e-mail opcional gravado. O envio do e-mail é feito pela camada de notificação. Migrado do legado IndividualPayment/InvoiceFuturePayment. **(Requer Authorization para autenticação)**
 * @summary Antecipa a emissão da nota fiscal no pagamento futuro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoice-future-payment}
 */
export async function postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentPathParams["parcelId"],
  params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePayment500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
